import React from "react";
import Reveal from "../common/Reveal";

const HIGHLIGHTS = [
  {
    metric: "+30% performance",
    desc: "Optimized query and schema design to cut response times for AI-powered and RAG-based services.",
  },
  {
    metric: "−40% cloud cost",
    desc: "Designed a Local-First client architecture that reduced AWS S3 infrastructure costs.",
  },
  {
    metric: "Micro-frontends",
    desc: "Built a micro-frontend platform on Kubernetes, Docker, and Nginx, and led the Optimization Team.",
  },
  {
    metric: "Multi-region HRIS",
    desc: "Shipped a Django + Angular HRIS used across regions, deployed via GitLab CI/CD to AWS EC2 and S3.",
  },
  {
    metric: "AI + RAG systems",
    desc: "Delivered AI-infused broadcast editing and transcription tooling, plus RAG-based microservices.",
  },
];

const ACHIEVEMENTS = [
  {
    year: "2019 — 2023",
    title: "Graduated Cum Laude — BS Information Technology",
    org: "Quezon City University",
  },
  {
    year: "2023",
    title: "Capstone nominated for Best Capstone Research of the year",
    org: "Quezon City University",
  },
  {
    year: "2023 — 2025",
    title: "Promoted twice in two years — Junior Frontend to Fullstack Developer",
    org: "Media Meter, Inc.",
  },
  {
    year: "2024",
    title: "Led the Optimization Team and ran technical interviews for developer hires",
    org: "Media Meter, Inc.",
  },
];

const STATS = [
  { value: "10", label: "PRODUCTS SHIPPED" },
  { value: "4", label: "TEAMS" },
  { value: "3+", label: "YEARS BUILDING" },
  { value: "20+", label: "TECHNOLOGIES" },
];

export default function About() {
  return (
    <section id="about" className="section" style={{ paddingTop: "110px" }}>
      <div className="section-inner">
        <Reveal className="section-label-row">
          <span className="section-label mono">01 / ABOUT</span>
          <span className="section-line" />
        </Reveal>

        <div className="about-grid">
          <div className="about-statement">
            <Reveal as="h2">
              I specialize in backend, DevOps, and AI-powered systems — the
              APIs behind a product, the databases beneath them, and the
              infrastructure that ships and scales the whole thing.
            </Reveal>
          </div>
          <div className="about-copy">
            <Reveal as="p">
              My name is John Paulo Ramil Guimalan. I started building during
              the pandemic — launchers, small tools, a library of programming
              books for friends who couldn't find good resources. That habit
              of shipping never stopped.
            </Reveal>
            <Reveal as="p">
              Today I focus on building scalable APIs, optimizing databases,
              and deploying services with Django, FastAPI, PostgreSQL,
              Docker, Kubernetes, AWS, and CI/CD — including RAG and
              AI-powered workflows. I've architected microservices, cut
              response times, and shipped platforms used across regions.
            </Reveal>
            <Reveal as="p">
              What I care about most: systems that scale cleanly, interfaces
              that feel obvious, and shipping things people actually use.
            </Reveal>
          </div>
        </div>

        <Reveal className="subsection">
          <div className="subsection-label mono">HIGHLIGHTS</div>
          <div className="highlights-grid stagger">
            {HIGHLIGHTS.map((h) => (
              <Reveal as="div" className="highlight-card" key={h.metric}>
                <span className="highlight-metric mono">{h.metric}</span>
                <p className="highlight-desc">{h.desc}</p>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <Reveal className="subsection tight">
          <div className="subsection-label mono">ACHIEVEMENTS</div>
          <div className="achievements-list stagger">
            {ACHIEVEMENTS.map((a) => (
              <Reveal as="div" className="achievement-row" key={a.title}>
                <span className="achievement-year mono">{a.year}</span>
                <div className="achievement-body">
                  <p className="achievement-title">{a.title}</p>
                  <p className="achievement-org mono">{a.org}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Reveal>

        <Reveal className="stats-grid stagger">
          {STATS.map((s) => (
            <div key={s.label}>
              <div className="stat-value mono">{s.value}</div>
              <div className="stat-label mono">{s.label}</div>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
